// sample request constants
export let PENDING_STATUS = 'PENDING'
export let COLLECTED_STATUS = 'COLLECTED'
export let APPROVED_STATUS = 'APPROVED'
export let DECLINED_STATUS = 'DECLINED'

//API URI constants
export let API_BASE_URL='127.0.0.1/api'

// Fonts constants
export let font_scale='1.5'